// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"902":"ec883573","958":"775c0032"}[chunkId] + ".chunk.js";
};